module.exports = __webpack_public_path__ + "img/ops-fc.8d00d736.png";